import {HttpClient, POST, expectEither} from '@raison/network-facade';
import {AccountId, TransactionIdIoTs} from '@raison/types';
import {string, type} from 'io-ts';
import {CryptoCurrencyType} from '~/entities/currencies';
import {BlockchainInfo, TransactionHolder, signCryptoTransaction} from '~/entities/operations-crypto';

export async function submitTravelRuleCommit(
    http: HttpClient,
    data: {
        holder: TransactionHolder;
        wallet: {
            id: AccountId;
            type: CryptoCurrencyType;
            blockchain: BlockchainInfo;
        };
        codeFromSms: string;
    }
) {
    const signature = await signCryptoTransaction(http, data);
    if (signature.status !== 'Ok') {
        return signature;
    }

    const url = (() => {
        switch (data.wallet.type) {
            case 'crypto':
                return `v1/operations/${data.wallet.id}/send_crypto_tr/commit`;
            case 'stablecoin':
                return `v1/operations/${data.wallet.id}/send_token_tr/commit`;
        }
    })();

    const response = await http(url, POST(signature.datum)).then(
        ...expectEither({
            200: type({id: TransactionIdIoTs}),
            201: type({id: TransactionIdIoTs}),
            400: type({message: string}),
        })
    );
    if (response.status === 'Abort') {
        return response;
    }
    if (response.status === 400) {
        return {status: 'BadRequest', datum: response.json.message} as const;
    }

    return {status: 'Ok', datum: {id: response.json.id}} as const;
}
